export const allMenuItems = [
  {
    label: "Menü",
    isHeader: true,
  },
  {
    id: "anasayfa",
    label: "Ana Sayfa",
    icon: "bx bxs-dashboard",
    link: "/dashboard",
  },
  {
    label: "İşlemler",
    isHeader: true,
  },

  {
    id: "siparisler",
    label: "Servisler",
    icon: "bx bx-shopping-bag",
    link: "/orders",
  },

  // {
  //   id: "hakedisler",
  //   label: "Hak Edişler",
  //   icon: "bx bx-calculator",
  //   link: "/progress-payment",
  // },

  {
    id: "firmalar",
    label: "Firmalar",
    icon: "bx bx-buildings",
    link: "/company",
  },

  {
    id: "musteriler",
    label: "Müşteriler",
    icon: "bx bx-building-house",
    link: "/customer",
  },

  {
    id: "kullanicilar",
    label: "Kullanıcılar",
    icon: "bx bx-user",
    link: "/user",
  },
];
